import { render, staticRenderFns } from "./rating.vue?vue&type=template&id=04ca739e&scoped=true&"
import script from "./rating.vue?vue&type=script&lang=js&"
export * from "./rating.vue?vue&type=script&lang=js&"
import style0 from "./rating.vue?vue&type=style&index=0&id=04ca739e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ca739e",
  null
  
)

export default component.exports